module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    attrs: {
      "id": "overview-panel"
    }
  }, [_c('v-layout', {
    staticStyle: {
      "margin-top": "-10px"
    },
    attrs: {
      "row": "",
      "wrap": ""
    }
  }, [_c('v-flex', {
    attrs: {
      "d-flex": "",
      "xs12": ""
    }
  }, [_c('v-card', [_c('v-jumbotron', {
    staticClass: "overview-jumbotron",
    attrs: {
      "gradient": _vm.gradient,
      "dark": ""
    }
  }, [_c('v-container', {
    attrs: {
      "fill-height": ""
    }
  }, [_c('v-layout', {
    attrs: {
      "row": "",
      "wrap": ""
    }
  }, [_c('v-flex', {
    attrs: {
      "xs12": ""
    }
  }, [_c('v-flex', {
    staticStyle: {
      "margin-top": "50px"
    },
    attrs: {
      "text-xs-center": ""
    }
  }, [_c('span', [_c('h1', {
    staticClass: "display-2 font-weight-thin mb-3",
    staticStyle: {
      "color": "white",
      "display": "inline",
      "font-family": "quicksand !important"
    }
  }, [_vm._v("panel.iobio")]), _vm._v(" "), _c('br'), _c('br')]), _vm._v(" "), _c('h4', {
    staticClass: "subheading",
    staticStyle: {
      "font-size": "17px !important"
    }
  }, [_vm._v("Generate list of genes based on suspected conditions and phenotypes.")]), _vm._v(" "), _c('br'), _c('br'), _c('br'), _vm._v(" "), _c('v-layout', {
    attrs: {
      "row": "",
      "wrap": ""
    }
  }, [_c('v-flex', {
    attrs: {
      "xs12": "",
      "md1": "",
      "lg3": "",
      "xl3": ""
    }
  }), _vm._v(" "), _c('v-flex', {
    attrs: {
      "xs12": "",
      "md5": "",
      "lg3": "",
      "xl3": ""
    }
  }, [_c('v-flex', {
    attrs: {
      "text-xs-center": ""
    }
  }, [_c('h4', {
    staticStyle: {
      "color": "white",
      "display": "inline"
    }
  }, [_vm._v("Suspected Conditions ")]), _vm._v(" "), _c('v-tooltip', {
    attrs: {
      "top": ""
    }
  }, [_c('span', {
    staticStyle: {
      "cursor": "pointer"
    },
    attrs: {
      "slot": "activator"
    },
    slot: "activator"
  }, [_c('v-icon', {
    attrs: {
      "small": ""
    }
  }, [_vm._v("help")])], 1), _vm._v(" "), _c('span', [_vm._v("Generate a gene list for suspected condition (Eg. Treacher Collins Syndrome)")])]), _vm._v(" "), _c('br'), _c('br'), _vm._v(" "), _c('v-btn', {
    staticStyle: {
      "color": "#0D47A1"
    },
    attrs: {
      "round": "",
      "color": "white"
    },
    on: {
      "click": function($event) {
        _vm.getStarted('gtr')
      }
    }
  }, [_vm._v("\n                          Genetic Testing Registry "), _c('v-icon', [_vm._v("play_arrow")])], 1)], 1)], 1), _vm._v(" "), _c('div', {
    staticClass: "vl"
  }), _vm._v(" "), _c('v-flex', {
    attrs: {
      "xs12": "",
      "md5": "",
      "lg3": "",
      "xl3": ""
    }
  }, [_c('v-flex', {
    attrs: {
      "text-xs-center": ""
    }
  }, [_c('div', {
    staticClass: "hl"
  }), _vm._v(" "), _c('div', {
    staticClass: "phenolyzer-button-div"
  }, [_c('h4', {
    staticStyle: {
      "color": "white",
      "display": "inline"
    }
  }, [_vm._v("Suspected Phenotypes ")]), _vm._v(" "), _c('v-tooltip', {
    attrs: {
      "top": ""
    }
  }, [_c('span', {
    staticStyle: {
      "cursor": "pointer"
    },
    attrs: {
      "slot": "activator"
    },
    slot: "activator"
  }, [_c('v-icon', {
    attrs: {
      "small": ""
    }
  }, [_vm._v("help")])], 1), _vm._v(" "), _c('v-container', {
    attrs: {
      "grid-list-xs,sm,md,lg,xl": ""
    }
  }, [_c('span', {
    staticStyle: {
      "margin": "auto",
      "margin-left": "20px",
      "margin-right": "20px"
    }
  }, [_vm._v("Generate a gene list for suspected phenotype (Eg. Lactic acidosis) using the Phenolyzer. ")])])], 1), _vm._v(" "), _c('br'), _c('br'), _vm._v(" "), _c('v-btn', {
    staticStyle: {
      "color": "#0D47A1"
    },
    attrs: {
      "round": "",
      "color": "white"
    },
    on: {
      "click": function($event) {
        _vm.getStarted('phenolyzer')
      }
    }
  }, [_vm._v("\n                            Phenolyzer "), _c('v-icon', [_vm._v("play_arrow")])], 1)], 1)])], 1), _vm._v(" "), _c('v-flex', {
    attrs: {
      "xs12": "",
      "md1": "",
      "lg3": "",
      "xl3": ""
    }
  })], 1)], 1)], 1)], 1)], 1)], 1)], 1)], 1)], 1), _vm._v(" "), _c('v-layout', {
    staticStyle: {
      "margin-left": "15px",
      "margin-right": "15px"
    },
    attrs: {
      "row": "",
      "wrap": "",
      "id": "gtr"
    }
  }, [_c('v-flex', {
    attrs: {
      "xs12": "",
      "md12": "",
      "sm12": "",
      "lg6": "",
      "xl6": ""
    }
  }, [_c('v-flex', {
    staticStyle: {
      "margin-top": "40px"
    }
  }, [_c('v-container', [_c('h2', {
    staticClass: "font-weight-thin mb-3",
    attrs: {
      "text-xs-center": ""
    }
  }, [_c('img', {
    staticStyle: {
      "height": "65px",
      "width": "55px"
    },
    attrs: {
      "src": require("../assets/images/ncbi.png"),
      "alt": "NCBI logo"
    }
  }), _vm._v(" Genetic Testing Registry")]), _vm._v(" "), _c('p', {
    staticStyle: {
      "text-align": "justify",
      "font-size": "14px"
    }
  }, [_vm._v("\n            The Genetic Testing Registry (GTR®) is an NCBI resource that compiles genetic test information that has been voluntarily submitted by multiple providers. "), _c('br'), _vm._v("\n            Panel.iobio allows you to search for one or more disorders, and generates a list of all of genes appearing on panels associated with these disorders. The list is sorted with genes appearing on the most panels at the top. The list can then be filtered based on your own specific requirements.\n          ")]), _vm._v(" "), _c('br'), _vm._v(" "), _c('a', {
    attrs: {
      "href": "http://iobio.io/user_guides/2018/10/28/how-to-use-gtr/",
      "target": "_blank"
    }
  }, [_c('v-btn', {
    staticStyle: {
      "color": "#0D47A1"
    },
    attrs: {
      "color": "white"
    }
  }, [_vm._v("\n            Learn More\n            ")])], 1), _vm._v(" "), _c('a', {
    attrs: {
      "href": "https://www.ncbi.nlm.nih.gov/gtr/",
      "target": "_blank"
    }
  }, [_c('v-btn', {
    attrs: {
      "color": "primary"
    }
  }, [_vm._v("\n              About GTR\n            ")])], 1), _vm._v(" "), _c('v-btn', {
    attrs: {
      "color": "primary"
    },
    on: {
      "click": function($event) {
        _vm.getStarted('gtr')
      }
    }
  }, [_vm._v("\n            Get Started\n          ")])], 1)], 1)], 1), _vm._v(" "), _c('v-flex', {
    attrs: {
      "xs12": "",
      "md12": "",
      "sm12": "",
      "lg5": "",
      "xl5": ""
    }
  }, [_c('v-flex', {
    attrs: {
      "text-xs-center": ""
    }
  }, [_c('img', {
    staticStyle: {
      "margin-top": "68px",
      "right": "0",
      "width": "590px"
    },
    attrs: {
      "src": require("../assets/images/gtrBackground.svg"),
      "alt": "Gtr background image"
    }
  })])], 1)], 1), _vm._v(" "), _c('v-divider'), _vm._v(" "), _c('v-layout', {
    staticStyle: {
      "margin-left": "5px",
      "margin-right": "15px"
    },
    attrs: {
      "row": "",
      "wrap": "",
      "id": "phenolyzer"
    }
  }, [_c('v-flex', {
    attrs: {
      "xs12": "",
      "md12": "",
      "sm12": "",
      "lg6": "",
      "xl6": "",
      "order-md2": "",
      "order-sm2": "",
      "order-xs2": "",
      "order-lg1": "",
      "order-xl1": ""
    }
  }, [_c('v-flex', {
    attrs: {
      "text-xs-center": ""
    }
  }, [_c('img', {
    staticStyle: {
      "margin-top": "68px",
      "right": "0",
      "width": "600px"
    },
    attrs: {
      "src": require("../assets/images/phenolyzer1bg.svg"),
      "alt": "Phenolyzer background image"
    }
  })])], 1), _vm._v(" "), _c('v-flex', {
    attrs: {
      "xs12": "",
      "md12": "",
      "sm12": "",
      "lg5": "",
      "xl5": "",
      "order-md-1": "",
      "order-sm1": "",
      "order-xs1": "",
      "order-lg2": "",
      "order-xl2": ""
    }
  }, [_c('v-flex', {
    staticStyle: {
      "margin-top": "40px",
      "margin-left": "15px"
    }
  }, [_c('v-container', [_c('h2', {
    staticClass: "font-weight-thin mb-3",
    attrs: {
      "text-xs-center": ""
    }
  }, [_c('img', {
    staticStyle: {
      "height": "65px",
      "width": "55px"
    },
    attrs: {
      "src": require("../assets/images/phenolyzer_icon_active.svg"),
      "alt": "NCBI logo"
    }
  }), _vm._v(" Phenolyzer")]), _vm._v(" "), _c('p', {
    staticStyle: {
      "text-align": "justify",
      "font-size": "14px"
    }
  }, [_vm._v("\n            Phenolyzer is a tool from the "), _c('a', {
    attrs: {
      "href": "http://wglab.org/",
      "target": "_blank"
    }
  }, [_vm._v("Wang Genomics lab")]), _vm._v(", that converts discrete phenotype terms into a list of candidate genes.\n            "), _c('br'), _vm._v("This is achieved by interpreting the phenotype term into a set of disease names.\n            Then, all genes having a reported association with these diseases are found, then expands this list by considering gene-gene relation databases.\n            Finally, all this information is integrated to generate a weighted score for each gene.\n          ")]), _vm._v(" "), _c('br'), _vm._v(" "), _c('a', {
    attrs: {
      "href": "http://iobio.io/user_guides/2018/10/27/how-to-use-phenolyzer/",
      "target": "_blank"
    }
  }, [_c('v-btn', {
    staticStyle: {
      "color": "#0D47A1"
    },
    attrs: {
      "color": "white"
    }
  }, [_vm._v("\n            Learn More\n            ")])], 1), _vm._v(" "), _c('a', {
    attrs: {
      "href": "http://phenolyzer.wglab.org/",
      "target": "_blank"
    }
  }, [_c('v-btn', {
    attrs: {
      "color": "primary"
    }
  }, [_vm._v("\n              About Phenolyzer\n            ")])], 1), _vm._v(" "), _c('v-btn', {
    attrs: {
      "color": "primary"
    },
    on: {
      "click": function($event) {
        _vm.getStarted('phenolyzer')
      }
    }
  }, [_vm._v("\n            Get Started\n          ")])], 1)], 1)], 1)], 1), _vm._v(" "), _c('br'), _vm._v(" "), _c('v-container', {
    staticStyle: {
      "min-height": "200px"
    },
    attrs: {
      "fluid": "",
      "grid-list-md": ""
    }
  })], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-656ea90e","hasScoped":false}!./~/vue-loader/lib/selector.js?type=template&index=0!./client/app/components/pages/Overview.vue
// module id = 509
// module chunks = 0